import type { ValidationError } from '@capture/shared';
import { getFindingAction } from '@capture/shared';
import styles from './ValidationFinding.module.css';

export interface ValidationFindingProps {
  error: ValidationError;
  /** Layout variant. `'tooltip'` (default) is tighter; `'inline'` is a card-like block. */
  variant?: 'tooltip' | 'inline';
  /** When provided, the message line wraps in a clickable button. */
  linkTarget?: { onClick: () => void; label?: string };
}

const ICON_BY_SEVERITY: Record<ValidationError['severity'], string> = {
  error: 'ⓧ',
  warn: '⚠',
};

export function ValidationFinding({ error, variant = 'tooltip', linkTarget }: ValidationFindingProps) {
  const messageContent = linkTarget ? (
    <button
      type="button"
      className={styles.messageButton}
      onClick={linkTarget.onClick}
      aria-label={linkTarget.label ?? error.message}
    >
      {error.message}
    </button>
  ) : (
    <div className={styles.message}>{error.message}</div>
  );

  return (
    <div
      className={`${styles.finding} ${styles[`finding--${variant}`]} ${styles[`finding--${error.severity}`]}`}
      data-severity={error.severity}
      data-variant={variant}
    >
      <span className={styles.icon} aria-hidden="true">
        {ICON_BY_SEVERITY[error.severity]}
      </span>
      <div className={styles.body}>
        {messageContent}
        <div className={styles.action}>{getFindingAction(error.code)}</div>
      </div>
    </div>
  );
}
